import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../store';
import * as AccountStore from '../store/accountStore';
import * as CarrelloStore from '../store/carrelloStore';
import * as CataloghiStore from '../store/cataloghiStore';
import { FormInstance } from "antd/lib/form";
import { Card, Col, Row, Space, Typography, Image, Descriptions, Divider, Form, InputNumber, Button, Menu, Dropdown, Modal, Input, PageHeader, message, notification, Spin, Empty } from 'antd';
import { EyeOutlined, DownOutlined, LoadingOutlined, MinusOutlined, PlusOutlined, CheckOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { msg_requiredField } from '../utils/constants';
import ZuFormDetail from '../Zerouno/ZuFormDetail';
import noImg from './noImg.png';
import CatStatisticheSelect from './select/CatStatisticheSelect';

const { Title, Paragraph } = Typography;
const BASEPATHIMMAGINI = "StaticFiles";

class ArticoliDetailComponent extends ZuFormDetail {
    formRef = React.createRef<FormInstance>();
    formRefNewWishlist = React.createRef<FormInstance>();

    state = {
        articolo: [] as any,
        cataloghi: [] as any,
        src: undefined,
        visible: false,
        currentImg: 0,
        creaCatalogo: false,
        loadingBtn: false,
        loadingAggiuntaCatalogo: false,
        visibleUpdateQta: false,
        quantita: 1,
        loadingPreventivo: false,
        articoloNonTrovato: false,
    }

    componentDidUpdate = (propsPrecedenti: any) => {
        if (propsPrecedenti.cataloghi != this.props.cataloghi) {
            let cataloghi = Object.values(this.props.cataloghi);
            this.setState({ cataloghi: cataloghi });
        }
    }

    async componentDidMount() {

        const url = `api/Articoli/${this.props.match.params.id}`;
        const response = await fetch(url, {});
        const res = await response;
        let articolo = {} as any;
        if (res.ok) {
            articolo = (await res.json()) || {};

            var src = null;
            var currentImg = 0;        

            if (articolo.immaginedefault) {
                src = articolo.immaginedefault;
                currentImg = articolo?.immagini?.indexof(articolo.immaginedefault);
            } else {
                if (articolo?.immagini?.length > 0) src = articolo.immagini[0];
            }

            let cataloghi = [] as any;
            if (this.props.cataloghi != null) {
                cataloghi = Object.values(this.props.cataloghi);
            }

            this.formRef.current?.setFieldsValue({ quantita: 1 });
            this.setState({ articolo: articolo, src: src, currentImg: currentImg, cataloghi: cataloghi })
        }
        else {
            this.setState({ articolo: articolo, src: src, currentImg: 0, cataloghi: [], articoloNonTrovato: true })
        }
    }

    aggiornaCataloghi = async () => {
        var res = await fetch("/api/Cataloghi/GetCataloghi");
        var json = res.ok && await res.json();
        if (json) {
            if (json && Object.keys(json).length === 0 && Object.getPrototypeOf(json) === Object.prototype) {
                //Risposta vuota no carrello
                this.props.setCataloghi([]);
                this.setState({ creaCatalogo: false, loadingBtn: false, loadingAggiuntaCatalogo: false });
                return;
            } else {
                let cataloghi = json;
                // descrizioneLinea = json.descrizione;
                this.props.setCataloghi(cataloghi);
                notification.success({ message: 'Articolo aggiunto al catalogo' })
                this.setState({ creaCatalogo: false, loadingBtn: false, loadingAggiuntaCatalogo: false });
                return;
            }
        }
    }


    aggiungiArticoloAlCatalogo = async (idCatalogo: any) => {
        this.setState({ loadingAggiuntaCatalogo: true });
        let model = { idCatalogo: idCatalogo, idArticolo: this.state.articolo.id };

        const response = await fetch("api/Cataloghi/AddArticolo", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                ...model
            })
        });
        const res = await response;
        let data: any = {};

        if (res.ok) {
            // data = await (res.ok && res.json()) || {};
            setTimeout(this.aggiornaCataloghi, 1000);
        }
        else {
            message.error("Errore");
            this.setState({ loadingAggiuntaCatalogo: false });
        }
    }

    creaCatalogoAggiungiArticolo = async (values: any) => {
        this.setState({ loadingAggiuntaCatalogo: true });
        let model = { descrizione: values.nomeCatalogo, idArticolo: this.state.articolo.id };

        const response = await fetch("api/Cataloghi/CreateCatalogoAddArticolo", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                ...model
            })
        });
        const res = await response;
        let data: any = {};

        if (res.ok) {
            // data = await (res.ok && res.json()) || {};
            setTimeout(this.aggiornaCataloghi, 1000);
        }
        else {
            message.error("Errore");
            this.setState({ loadingAggiuntaCatalogo: false });
        }
    }

    aggiornaCarrello = async () => {
        var res = await fetch("/api/Carrelli/GetCarrello");
        var json = res.ok && await res.json();
        if (json) {
            if (json && Object.keys(json).length === 0 && Object.getPrototypeOf(json) === Object.prototype) {
                //Risposta vuota no carrello
                this.props.setCarrello([]);
                this.setState({ loadingBtn: false });
                return;
            } else {
                let carrello = json.articoliQta;
                // descrizioneLinea = json.descrizione;
                this.props.setCarrello(carrello);
                this.setState({ loadingBtn: false });
                const btn = (
                    <Button type='primary' onClick={()=> {this.props.history.push('/Carrello'); notification.close('articoloaggiuntocarrello')}}><ShoppingCartOutlined /> Vai al carrello</Button>
                  );
                notification.success({ message: 'Articolo aggiunto al carrello', description: btn, key: 'articoloaggiuntocarrello' })
                return;
            }
        }

    }

    aggiungiArticoloAlCarrello = async () => {
        this.setState({ loadingBtn: true });
        let model = { idArticolo: this.state.articolo.id, quantita: this.state.quantita, idCatStatistica: this.formRef.current?.getFieldValue("colore") };

        const response = await fetch("api/Carrelli/AddArticolo", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                ...model
            })
        });
        const res = await response;
        let data: any = {};

        if (res.ok) {
            // data = await (res.ok && res.json()) || {};
            setTimeout(this.aggiornaCarrello, 1000);
        }
        else {
            message.error("Errore");
            this.setState({ loadingBtn: false });
        }
    }

    richiediPreventivo = async () => {
        this.setState({ loadingPreventivo: true })
        const { articolo } = this.state;
        let model = [] as any;
        let d = { idArticolo: articolo.id, descrizione: articolo.descrizione, quantita: this.state.quantita };
        model.push(d);

        const response = await fetch("api/Carrelli/GetPreventivoArticolo", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                listaArticoli: model
            })
        });
        const res = await response;
        let data: any = {};

        if (res.ok) {
            // data = await (res.ok && res.json()) || {};
            notification.success({ message: 'Richiesta preventivo inviata con successo' })
            this.setState({ loadingPreventivo: false })
        }
        else {
            message.error("Errore");
            this.setState({ loadingPreventivo: false })
        }
    }

    render() {
        const { visible, src, articolo, currentImg, creaCatalogo, loadingBtn, loadingAggiuntaCatalogo, visibleUpdateQta, quantita, loadingPreventivo, articoloNonTrovato } = this.state;
        const menuListe = (
            <Menu>
                {(this.state.cataloghi || []).map((x: any) =>
                    <Menu.Item key={x.id} onClick={() => this.aggiungiArticoloAlCatalogo(x.id)}>{x.descrizione}</Menu.Item>
                )}
                <Menu.Item key={"add"} onClick={() => this.setState({ creaCatalogo: true })} style={{ color: '#1890ff' }}>+ Crea un catalogo</Menu.Item>
            </Menu>
        );

        return (
            <>
                {creaCatalogo &&
                    <Modal
                        visible={creaCatalogo}
                        title="Crea nuovo catalogo"
                        onOk={() => this.formRefNewWishlist.current?.submit()}
                        onCancel={() => this.setState({ creaCatalogo: false })}
                        maskClosable={false}
                        forceRender={true} // necessario !!!
                        width={800}
                        okButtonProps={{ loading: loadingAggiuntaCatalogo }}
                    >
                        <Form ref={this.formRefNewWishlist} layout="vertical" onFinish={this.creaCatalogoAggiungiArticolo} >
                            <Row gutter={16}>
                                <Col md={24} xs={24}>
                                    <Form.Item label="Nome catalogo" name="nomeCatalogo" rules={[{ required: true, message: msg_requiredField }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Modal>
                }
                <PageHeader
                    style={{ border: '1px solid rgb(235, 237, 240)', marginBottom: 4 }}
                    ghost={false}
                    onBack={() => window.history.back()}
                    title={"Articolo"}
                >
                </PageHeader>
                {articoloNonTrovato ?
                    <Card>
                        <Empty description="Articolo non trovato" />
                    </Card>
                    :
                    <Card>
                        <Row gutter={16}>
                            <Col md={12} style={{ textAlign: 'center' }}>
                                <Row gutter={16}>
                                    <Col md={6}>
                                        <Space direction="vertical">
                                            {articolo?.immagini?.length > 0 ?
                                                (articolo.immagini || []).map((x: any, i: number) =>
                                                    <Image
                                                        key={x}
                                                        preview={false}
                                                        //width={75}
                                                        src={`${BASEPATHIMMAGINI}/${x}?t=${articolo.ultimamodifica}`}
                                                        onClick={() => this.setState({ src: x, currentImg: i })}
                                                        style={{ cursor: 'pointer', objectFit: 'cover', objectPosition: 'center center', width: 75, height: 75 }}
                                                    />
                                                )
                                                :
                                                <Image
                                                    width={75}
                                                    height={75}
                                                    src={noImg}
                                                    preview={false}
                                                //fallback="data:image/png;base64,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"
                                                />
                                            }
                                        </Space>
                                    </Col>
                                    <Col md={18}>
                                        {articolo?.immagini?.length > 0 ?
                                            (<>
                                                <Image
                                                    preview={{ visible: false, mask: <EyeOutlined /> }}
                                                    width={'70%'}
                                                    // height={'auto'}
                                                    src={`${BASEPATHIMMAGINI}/${src}?t=${articolo.ultimamodifica}`}
                                                    onClick={() => this.setState({ visible: true })}
                                                    style={{ aspectRatio: '1/1', objectFit: 'cover', objectPosition: 'center center' }}
                                                />
                                                <div style={{ display: 'none' }}>
                                                    <Image.PreviewGroup preview={{ visible, onVisibleChange: (vis: any) => this.setState({ visible: vis }), current: currentImg }}>
                                                        {(articolo.immagini || []).map((x: any) => <Image key={x} src={`${BASEPATHIMMAGINI}/${x}?t=${articolo.ultimamodifica}`} />)}
                                                    </Image.PreviewGroup>
                                                </div>
                                            </>)
                                            :
                                            (
                                                <Image
                                                    width={200}
                                                    height={200}
                                                    src={noImg}
                                                    preview={false}
                                                //fallback="data:image/png;base64,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"
                                                />
                                            )
                                        }
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={12}>
                                <Title level={4}>{articolo.id}</Title>
                                <Title level={5}>{articolo.descrizione}</Title>
                                {articolo.descrizionelunga && <Paragraph ellipsis={{ rows: 2 }}>{articolo.descrizionelunga}</Paragraph>}
                                <Form layout="vertical" style={{ marginTop: 32 }}>
                                    <Form.Item label="Aggiungi al catalogo" name="layout" style={{ width: '50%' }}>
                                        <Space>
                                            {this.state.cataloghi?.length > 0 ?
                                                <Dropdown.Button disabled={loadingAggiuntaCatalogo} trigger={['click']} onClick={() => this.aggiungiArticoloAlCatalogo(this.state.cataloghi[0].id)} overlay={menuListe} icon={<DownOutlined />}>
                                                    {this.state.cataloghi[0].descrizione}
                                                </Dropdown.Button>
                                                :
                                                <Button onClick={() => this.setState({ creaCatalogo: true })}>Crea il mio catalogo</Button>
                                            }
                                            {loadingAggiuntaCatalogo && <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />}
                                        </Space>
                                    </Form.Item>
                                </Form>
                                <Divider />
                                <Form layout="vertical" ref={this.formRef} initialValues={{ quantita: quantita }}>
                                    <Form.Item label="Quantità" name="quantita" >
                                        {/* <InputNumber size="large" min={1} max={100000} /> */}
                                        {visibleUpdateQta ?
                                            <Space size={[0, 0]}>
                                                <InputNumber
                                                    min={1}
                                                    max={100000}
                                                    value={quantita}
                                                    onChange={(value: any) => this.setState({ quantita: value })}
                                                />
                                                <Button onClick={() => this.setState({ visibleUpdateQta: false })} icon={<CheckOutlined style={{ fontSize: 12 }} />} />
                                            </Space>
                                            :
                                            <Space>
                                                <Button disabled={quantita === 1} icon={<MinusOutlined style={{ fontSize: 12 }} />} onClick={() => this.setState({ quantita: this.state.quantita - 1 })} />
                                                <Button type="text" onClick={() => this.setState({ visibleUpdateQta: true })}>{quantita}</Button>
                                                <Button icon={<PlusOutlined style={{ fontSize: 12 }} />} onClick={() => this.setState({ quantita: this.state.quantita + 1 })} />
                                            </Space>
                                        }
                                    </Form.Item>
                                    <Form.Item label="Colore" name="colore" >
                                        <CatStatisticheSelect />
                                    </Form.Item>
                                    <Form.Item >
                                        <Space direction='vertical' style={{ width: '100%' }}>
                                            <Button size='large' block onClick={this.aggiungiArticoloAlCarrello} type="primary" loading={loadingBtn}>Aggiungi al carrello</Button>
                                            <Button size='large' block onClick={this.richiediPreventivo} loading={loadingPreventivo}>Richiedi preventivo</Button>
                                        </Space>
                                    </Form.Item>
                                </Form>
                            </Col>
                        </Row>
                        <Row gutter={16} style={{ marginTop: 8 }}>
                            <Divider orientation="left">Scheda prodotto</Divider>
                            <Descriptions bordered column={2} size="small" style={{ width: '100%' }} labelStyle={{ fontWeight: 'bold', width: '15%' }}>
                                <Descriptions.Item label="Famiglia">{articolo.famiglia}</Descriptions.Item>
                                <Descriptions.Item label="Materiale">{articolo.classe}</Descriptions.Item>
                                <Descriptions.Item label="Marca">{articolo.marca}</Descriptions.Item>
                                <Descriptions.Item label="Misura">{articolo.natura}</Descriptions.Item>
                                <Descriptions.Item label="Cat. merceologica">{articolo.catmerc}</Descriptions.Item>
                            </Descriptions>
                        </Row>
                    </Card>
                }
            </>
        );
    };
};

export default connect(
    (state: ApplicationState) => ({ ...state.account, ...state.carrello, ...state.cataloghi }),
    { ...AccountStore.actionCreators, ...CarrelloStore.actionCreators, ...CataloghiStore.actionCreators }
)(ArticoliDetailComponent);